// extracted by mini-css-extract-plugin
module.exports = {"StatsCountShimmer":"StatsCountShimmer_StatsCountShimmer__lRKkM","titleWrapper":"StatsCountShimmer_titleWrapper__3HQuo"};